import React, { useState } from 'react';
import { ThreeDotsVertical, ToggleOff } from 'react-bootstrap-icons';
import styled from 'styled-components';
import Icon from '@designSystem/Icon';

const MenuComponent: React.FC<{ isCancellable: boolean; onCancel: () => void }> = ({
  isCancellable,
  onCancel
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <MenuContainer>
      <Icon onClick={toggleMenu} className="icon-link" size="small" variant="blue" iconSize="10px">
        <ThreeDotsVertical style={{ cursor: 'pointer' }} />
      </Icon>
      {isOpen && (
        <MenuDropdown>
          <MenuItem
            className={!isCancellable ? 'disabled' : ''}
            onClick={() => isCancellable && onCancel()}
          >
            <ToggleOff className="menu-icon" />
            <span>Annuler</span>
          </MenuItem>
        </MenuDropdown>
      )}
    </MenuContainer>
  );
};

const MenuContainer = styled.div`
  position: relative;
`;

const MenuDropdown = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 1000;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start !important;
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Aligne le contenu à gauche */
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;

  width: 100%;
  &:not(.disabled):hover {
    background-color: #f1f1f1;
  }

  &.disabled {
    cursor: not-allowed;
  }

  .menu-icon {
    margin-right: 8px;
  }
`;

export default MenuComponent;
